module.exports = __webpack_public_path__ + "static/media/bg.270d57a9.png";